import React from 'react';
import { MapPin, Navigation, Phone } from 'lucide-react';
import { business, serviceAreas } from '../data/site';
import { SectionHeading } from './SectionHeading';
export function ServiceAreas() {
  return <section id="areas" className="bg-white py-20 lg:py-28" data-id="element-173" data-mp="2lrcyz4ywjs5d">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-174" data-mp="2loqpgzsgb2ki">
        <SectionHeading eyebrow="Service Area" tone="light" title={<>
              We haul the shop
              <br data-id="element-176" data-mp="2gr747fxc5pj2" />
              to your gate
            </>} description="Mobile welding across Central Texas. Outside the radius? Call anyway — larger jobs travel." data-id="element-175" data-mp="2pqlry7m4blzv" />

        <div className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-177" data-mp="26taqqhgxeihs">
          <div className="border-2 border-steel-950 p-8" data-id="element-178" data-mp="26tsvy3lkg71u">
            <div className="flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.22em] text-steel-950" data-id="element-179" data-mp="zswv6zgg25f">
              <MapPin className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-180" data-mp="50moaac3vz32" />
              Primary Towns
            </div>
            <ul className="mt-6 space-y-3" data-id="element-181" data-mp="687vcgicfc5q">
              {serviceAreas.primary.map(town => <li key={town} className="flex items-baseline gap-3 border-b border-steel-100 pb-3 font-display text-xl font-semibold uppercase tracking-tight text-steel-950 last:border-0" data-id="element-182" data-mp="1ao5skg73cyh">
                  <span className="h-1.5 w-1.5 shrink-0 bg-brand" aria-hidden="true" data-id="element-183" data-mp="3jgav5sjaapg3" />
                  {town}
                </li>)}
            </ul>
          </div>

          <div className="bg-steel-50 p-8" data-id="element-184" data-mp="3eju6mx86a92h">
            <div className="flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.22em] text-steel-500" data-id="element-185" data-mp="3tfrzo6msuxah">
              <Navigation className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-186" data-mp="3oe2qkwj50tp1" />
              Also Serving
            </div>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-187" data-mp="18qcf3te6c4ta">
              {serviceAreas.extended.map(town => <li key={town} className="border border-steel-200 bg-white px-3 py-2 font-mono text-[11px] uppercase tracking-[0.14em] text-steel-600" data-id="element-188" data-mp="1asmvyb8gfaze">
                  {town}
                </li>)}
            </ul>
            <div className="mt-8 border-t border-steel-200 pt-6" data-id="element-189" data-mp="1koptf3sd2lg0">
              <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-steel-500" data-id="element-190" data-mp="1poko7if9bv6c">
                Counties
              </div>
              <p className="mt-3 font-display text-lg uppercase tracking-tight text-steel-950" data-id="element-191" data-mp="s0aj2uk6crb0">
                {serviceAreas.counties.join(' · ')}
              </p>
            </div>
          </div>

          <div className="flex flex-col justify-between bg-steel-950 p-8" data-id="element-192" data-mp="11ygi94eljjc6">
            <div data-id="element-193" data-mp="16scfg4n1d26a">
              <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-brand-light" data-id="element-194" data-mp="16suknqroeqqc">
                Not On The List?
              </div>
              <p className="mt-6 font-display text-3xl font-bold uppercase leading-[0.95] text-white" data-id="element-195" data-mp="e9ozf3mwcdc2">
                If it's steel and it's within a day's drive, we'll talk about it.
              </p>
              <p className="mt-4 text-sm leading-relaxed text-steel-300" data-id="element-196" data-mp="2nkpz3zwy0eus">
                Travel is quoted up front — you'll know the number before we hitch the trailer.
              </p>
            </div>
            <a href={business.phoneHref} className="mt-10 inline-flex items-center justify-center gap-3 bg-brand px-6 py-4 font-display text-sm font-semibold uppercase tracking-[0.16em] text-white transition-colors hover:bg-white hover:text-black" data-id="element-197" data-mp="2dkfl4d3333ek">
              <Phone className="h-4 w-4" aria-hidden="true" data-id="element-198" data-mp="1zuvkbct2cg7w" />
              {business.phone}
            </a>
          </div>
        </div>

        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-steel-300" data-id="element-199" data-mp="1usmu2o7krs9h">
          Placeholder service areas — confirm final coverage
        </p>
      </div>
    </section>;
}